module.exports = __webpack_public_path__ + "static/media/devops-azure-img-black.a8d15567.png";